import { Flex, Text, Image } from "@chakra-ui/react";
import ButtonSpoleto from "../Button";
import TitleSpoleto from "../Title";

const SuccessModalBody = ({ closeModal }) => {
  return (
    <Flex
      w="100%"
      py={12}
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <Image w="150px" src="assets/images/check_icon.svg" />
      <TitleSpoleto
        textAlign="center"
        color="#EFEBE1"
        fontSize={["30px", null, "40px"]}
        mb={0}
        mt={8}
      >
        SEU VOTO FOI <br /> REGISTRADO!
      </TitleSpoleto>
      <Text
        mt={6}
        mb={8}
        fontFamily="FiraSansRegular"
        fontSize="22px"
        color="#FDF6DC"
        maxW="80%"
        textAlign="center"
      >
        Sinta-se livre para votar mais quantas vezes quiser até o dia 11/04.
      </Text>
      <ButtonSpoleto
        backgroundColor="#F5B241"
        color="#331F12"
        shadow="0 0 0 2px #331F12"
        maxWidth={["75%", null, "90%"]}
        onClick={closeModal}
      >
        Fechar
      </ButtonSpoleto>
    </Flex>
  );
};

export default SuccessModalBody;
